import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black text-white py-16">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-14 h-14 flex items-center justify-center">
                <img 
                  src="https://customer-assets.emergentagent.com/job_learn-finance-5/artifacts/u8xwnrlt_Logo_Geldgymnasium_riesig.png" 
                  alt="GeldGymnasium Logo" 
                  className="w-full h-full object-contain"
                />
              </div>
              <div>
                <h3 className="text-2xl font-bold bg-gradient-to-r from-[#D4AF37] to-[#FFD700] bg-clip-text text-transparent">
                  GeldGymnasium
                </h3>
                <p className="text-sm text-gray-400">Finanzielle Bildung</p>
              </div>
            </div>
            <p className="text-gray-400 leading-relaxed max-w-md">
              Wir helfen Menschen dabei, finanzielle Kompetenz zu entwickeln und ihre wirtschaftliche 
              Zukunft selbstbestimmt zu gestalten. Von Grundlagen bis zur Meisterschaft.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-lg mb-4 text-[#FFD700]">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => {
                    const element = document.getElementById('hero');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-gray-400 hover:text-[#FFD700] transition-colors"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    const element = document.getElementById('courses');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-gray-400 hover:text-[#FFD700] transition-colors"
                >
                  Kurse
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    const element = document.getElementById('about');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-gray-400 hover:text-[#FFD700] transition-colors"
                >
                  Über Uns
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold text-lg mb-4 text-[#FFD700]">Kontakt</h4>
            <ul className="space-y-3">
              <li className="flex items-center space-x-3 text-gray-400">
                <Mail className="w-5 h-5 text-[#D4AF37]" />
                <span>info@geldgymnasium.de</span>
              </li>
              <li className="flex items-center space-x-3 text-gray-400">
                <Phone className="w-5 h-5 text-[#D4AF37]" />
                <a href="tel:+4917632819049" className="hover:text-[#FFD700] transition-colors">
                  +49 (0) 176 32819049
                </a>
              </li>
              <li className="flex items-start space-x-3 text-gray-400">
                <MapPin className="w-5 h-5 text-[#D4AF37] flex-shrink-0 mt-1" />
                <span>Deutschland</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} GeldGymnasium. Alle Rechte vorbehalten.
            </p>
            <div className="flex space-x-6">
              <a href="/datenschutz-agb" className="text-gray-400 hover:text-[#FFD700] transition-colors text-sm">
                Datenschutz & AGB
              </a>
              <a href="/impressum" className="text-gray-400 hover:text-[#FFD700] transition-colors text-sm">
                Impressum
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};